import React from 'react';
import { useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import useAxios from 'axios-hooks';
import { LanguageContext } from "../Helpers/Context";
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
    selectOffice: {
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
        },
        "& .MuiOutlinedInput-input": {
            color: "white"
        },
    },
}));

class OfficeResponse {
    offices!: number[];
};

export default function OfficeList() {
    const { officeId, setOfficeId } = useContext(LanguageContext);

    const classes = useStyles();

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setOfficeId(event.target.value as number);
    };

    const [{ data, loading }] = useAxios<OfficeResponse>(
        "Office"
    );

    return (
        <React.Fragment>
            {loading && (
                <CircularProgress />
            )}
            {data && !loading && (
                <TextField
                    className={classes.selectOffice}
                    variant="outlined"
                    size="small"
                    select
                    value={officeId}

                    onChange={handleChange}

                >
                    <MenuItem key={0} value={0}>&nbsp;</MenuItem>
                    {
                        data?.offices.map((item =>
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))
                    }
                </TextField>
            )}
        </React.Fragment>
    );
}


